import { LogLevel, LogService, postLogs } from "@/services/logging";
import { dexieDB } from "@/services/dexie-database";
import LogsModule from "@/store/modules/logs";

/**
 * Synchronize logs from DexieDB to Smeetz logging service.
 * This function is called periodically by the app.
 * It fetches logs from DexieDB, posts them to Smeetz logging service,
 * and then removes them from DexieDB.
 */
export async function syncLogs() {
  if (LogsModule.isSyncInProgress) {
    // avoid initiating another sync while another is still in progress
    return;
  }
  LogsModule.setIsSyncInProgress(true);
  try {
    const logs = await dexieDB.logs.orderBy("_id").limit(5).toArray();
    if (logs.length) {
      await postLogs(logs);
      const ids = logs.map((l) => l._id);
      await dexieDB.logs.where("_id").anyOf(ids).delete();
    }
  } catch (error) {
    await LogService.infoDirect(
      "Logs: Error when trying to sync logs from DexieDB",
      error,
      LogLevel.Error
    );
  } finally {
    LogsModule.setIsSyncInProgress(false);
  }
}
